export default __webpack_public_path__ + "29747565509bc028aa96978e414f1a0d.svg";